import React from 'react';
import qs from 'qs';
import ExpiredView from './ExpiredView';
import { useSecureQueryParameters } from 'hooks/useQueryParameters';
import env from 'utils/env';
const Expired: React.FC = props => {
  const allowedQueryParameters = useSecureQueryParameters();

  const restartPath = `${env.BASENAME}/prequal/phone-lookup${qs.stringify(
    allowedQueryParameters,
    {
      addQueryPrefix: true,
    },
  )}`;

  return <ExpiredView {...props} restartPath={restartPath} />;
};

export default Expired;
